import { HttpClient } from "@parkschannel/next-utils";
export class PlannerApi {
    getPlannerResources(filters) {
        return this.client.get("".concat(this.baseUrl, "/resource/trees"), {
            params: {
                resourceIds: filters
            }
        });
    }
    saveTripPlan(plan) {
        return this.client.post("".concat(this.baseUrl), plan);
    }
    getTripPlan(plannerId) {
        return this.client.get("".concat(this.baseUrl, "/").concat(plannerId));
    }
    getFilters() {
        return this.client.get("".concat(this.baseUrl, "/resource/filters"));
    }
    getUserTripPlans() {
        return this.client.get("".concat(this.baseUrl));
    }
    deleteTripPlan(plannerId) {
        return this.client.delete("".concat(this.baseUrl, "/").concat(plannerId));
    }
    getProductItems(productId) {
        return this.client.get("".concat(this.baseUrl, "/product-item/").concat(productId));
    }
    generatePDF(products, filters, name) {
        return this.client.post("/api/checklist/generatePdf", {
            products,
            filters,
            name
        }, {
            responseType: "arraybuffer",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/pdf"
            }
        });
    }
    constructor(client = new HttpClient()){
        this.client = client;
        this.baseUrl = "/api/planner";
    }
}
